import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';

const useStyles = makeStyles({
  cardRow: {
    marginTop: 10,
    marginBottom: 10,
  },
});

type PropItems = {
  left: React.ReactNode;
  right: React.ReactNode;
};

type Props = {
  children?: React.ReactNode;
  displayItems?: PropItems;
};

const DefaultCardRow = ({ children, displayItems }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.cardRow}>
      {typeof displayItems !== 'undefined' && (
        <Grid container>
          <Grid item xs={6}>
            {displayItems.left}
          </Grid>
          <Grid
            item
            xs={6}
            container
            alignItems="flex-end"
            justifyContent="flex-end"
          >
            {displayItems.right}
          </Grid>
        </Grid>
      )}
      {children}
    </div>
  );
};

export default DefaultCardRow;
